export const DEFAULT_AUTOCOMPLETE_CLASS_NAME = 'default-autocomplete';
export const CREDENTIAL_PROVIDER_AUTOCOMPLETE_CLASS_NAME = 'credential-provider-autocomplete';
export const FORM_SELECT_AUTOCOMPLETE_CLASS_NAME = 'form-select-autocomplete';
